import { useParams } from "react-router-dom";
import { Fragment, useEffect, useState } from "react";
import Breadcrumb from "../../../components/ui/breadcrumb/Breadcrumb";
import {
  getComments,
  getSingleArticle,
  postComment,
  updateArticle,
} from "../../../api/blog/blogAPI";
import ReactMarkdown from "react-markdown";
import ProductRecommendation from "../../common/recommendations/ProductRecommedation";
import LoadingPlaceholder from "../../../components/ui/loading/LoadingPlaceholder";
import CommentThread from "../../../components/ui/comments/CommentThread";
import { useSelector } from "react-redux";
import AuthModal from "../../../components/ui/popup/AuthModal";

function Article() {
  const { isAuthenticated } = useSelector((state) => state.auth);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [loadingArticle, setLoadingArticle] = useState(true);
  const [loadingComments, setLoadingComments] = useState(true);
  const [article, setArticle] = useState(null);
  const [comments, setComments] = useState([]);
  const { articleId } = useParams();

  async function fetchArticle() {
    setLoadingArticle(true);
    const apiUrl = "blog/article";

    const response = await getSingleArticle(apiUrl, articleId);
    if (response.status === 200) {
      const article = await response.json();
      setArticle(article);
      setLoadingArticle(false);
    } else {
      setLoadingArticle(false);
    }
  }

  async function fetchComments() {
    setLoadingComments(true);
    const apiUrl = "blog/article";
    try {
      // Replace this with your actual API utility call, e.g., getComments(articleId)
      const response = await getComments(apiUrl, articleId);
      if (response.ok) {
        const result = await response.json();
        setComments(result.data); // result.data matches the structure we built in Django
      }
    } catch (error) {
      console.error("Failed to fetch comments:", error);
    }
    setLoadingComments(false);
  }

  const handleVote = async (voteType) => {
    // voteType will be 1 for like, -1 for dislike
    const apiUrl = "blog/article"; // Adjust based on your API util

    try {
      // This calls your Django patch/post endpoint we discussed earlier
      const response = await updateArticle(apiUrl, articleId, {
        like: voteType,
      });

      if (response.status === 200) {
        const updatedArticle = await response.json();
        // Update local state so the numbers jump up immediately
        setArticle(updatedArticle);
      }
    } catch (error) {
      console.error("Error updating vote:", error);
    }
  };

  const handlePostCommentAttempt = async (text, parentId = null) => {
    if (!isAuthenticated) {
      setShowAuthModal(true);
      return;
    }

    // If authenticated, run the logic we built previously
    await handlePostComment(text, parentId);
  };

  const handlePostComment = async (text, parentId = null) => {
    try {
      const apiUrl = "blog/article";
      const response = await postComment(apiUrl, articleId, text, parentId);

      if (response.ok) {
        const newCommentData = await response.json();

        // If it's a top-level comment, add it to the list
        if (!parentId) {
          setComments([newCommentData.data, ...comments]);
        } else {
          // If it's a reply, we should probably just re-fetch
          // or find the parent in the state and update it.
          fetchComments();
        }
      }
    } catch (error) {
      console.error("Error posting comment:", error);
    }
  };

  useEffect(() => {
    fetchArticle();
    fetchComments();
  }, [articleId]);
  return (
    <Fragment>
      <div id="hybrid-container">
        <div className="hybrid-container-left">
          {loadingArticle ? (
            /* Skeleton for the full article view */
            <div className="article">
              <LoadingPlaceholder rows={1} type="line" />
              <LoadingPlaceholder rows={2} type="card-large" />
            </div>
          ) : article ? (
            <div className="article">
              <Breadcrumb
                items={[
                  { label: "Blog", to: "/blog" },
                  { label: article.title },
                ]}
              />
              <img
                src={article.creative}
                alt={article.title}
                className="article-image"
              />
              <h2 className="article-title">{article.title}</h2>
              <article className="article-body">
                <ReactMarkdown>{article.content}</ReactMarkdown>
              </article>
            </div>
          ) : (
            <div className="content">
              <Breadcrumb items={[{ label: "Blog", to: "/blog" }]} />
              <h5>Ups. Sorry, there was an issue loading this article!</h5>
            </div>
          )}

          {loadingComments || loadingArticle || !article ? (
            /* Skeleton for the full article view */
            <div className="article">
              <LoadingPlaceholder rows={2} type="card-large" />
            </div>
          ) : (
            <CommentThread
              comments={comments}
              likes={article.likes}
              dislikes={article.dislikes}
              userVote={article?.user_vote}
              onVote={handleVote}
              onPostComment={handlePostCommentAttempt}
            />
          )}
          {showAuthModal && (
            <AuthModal onClose={() => setShowAuthModal(false)} />
          )}
        </div>

        {/* RIGHT SIDE: Always visible */}
        <div className="hybrid-container-right">
          <ProductRecommendation />
        </div>
      </div>
    </Fragment>
  );
}

export default Article;
